import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../modals/CustomModal";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Clock = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 6.5C7.66304 6.5 8.29893 6.23661 8.76777 5.76777C9.23661 5.29893 9.5 4.66304 9.5 4C9.5 3.33696 9.23661 2.70107 8.76777 2.23223C8.29893 1.76339 7.66304 1.5 7 1.5C6.33696 1.5 5.70107 1.76339 5.23223 2.23223C4.76339 2.70107 4.5 3.33696 4.5 4C4.5 4.66304 4.76339 5.29893 5.23223 5.76777C5.70107 6.23661 6.33696 6.5 7 6.5ZM7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0ZM1.54062 14.5H10.8906C11.275 15.0875 11.7656 15.5969 12.3375 16H0.928125C0.415625 16 0 15.5844 0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H7H8.42813C9.07188 9.5 9.69063 9.60937 10.2656 9.80937C10.1125 10.2875 10.0219 10.7906 10.0031 11.3156C9.51875 11.1125 8.9875 11 8.42813 11H5.57188C3.51875 11 1.81875 12.5219 1.54062 14.5ZM11 11.5C11 10.3065 11.4741 9.16193 12.318 8.31802C13.1619 7.47411 14.3065 7 15.5 7C16.6935 7 17.8381 7.47411 18.682 8.31802C19.5259 9.16193 20 10.3065 20 11.5C20 12.6935 19.5259 13.8381 18.682 14.682C17.8381 15.5259 16.6935 16 15.5 16C14.3065 16 13.1619 15.5259 12.318 14.682C11.4741 13.8381 11 12.6935 11 11.5ZM15.5 9C15.225 9 15 9.225 15 9.5V11.5C15 11.775 15.225 12 15.5 12H17C17.275 12 17.5 11.775 17.5 11.5C17.5 11.225 17.275 11 17 11H16V9.5C16 9.225 15.775 9 15.5 9Z"
        fill="#439BD9"
      />
    </svg>
  );
};

const MaatwerkLoadingModal = ({ visible, setVisible, requestId }) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (!visible || !requestId) {
      setProgress(0);
      setStatus("");
      return;
    }

    const fetchProgress = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_BACKEND_URL}/run/get_progress/${requestId}`
        );
        if (response.ok) {
          const data = await response.json();
          setProgress(data.progress || 0);
          setStatus(data.status || "");
        }
      } catch (error) {
        console.error("Error fetching progress:", error);
      }
    };

    fetchProgress();
    const intervalId = setInterval(fetchProgress, 2000);

    return () => clearInterval(intervalId);
  }, [visible, requestId]);

  return (
    <CustomModal
      visible={visible}
      setVisible={setVisible}
      noBtn
      title={t("maatwerkLoading.title")}
      width="500px"
      notCloseable
    >
      <div style={{ textAlign: "center", padding: "10px 0" }}>
        <div
          style={{
            width: "60px",
            height: "60px",
            margin: "0 auto 20px",
            position: "relative",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "4px solid #e0e0e0",
              borderTop: "4px solid #439BD9",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              boxSizing: "border-box",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "12px",
              fontWeight: 600,
              color: "#439BD9",
            }}
          >
            {progress}%
          </div>
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>

        {status && (
          <p style={{ margin: "0 0 10px", color: "#439BD9", fontWeight: 500 }}>
            {t(`maatwerkLoading.status.${status}`, status)}
          </p>
        )}

        <div
          style={{
            width: "100%",
            backgroundColor: "#e0e0e0",
            borderRadius: "10px",
            height: "12px",
            margin: "0 0 15px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              backgroundColor: "#439BD9",
              height: "100%",
              borderRadius: "10px",
              transition: "width 0.3s ease",
            }}
          />
        </div>

        {/* <h3 style={{ margin: "0 0 10px", color: "#333", fontWeight: 500 }}>
          {t("maatwerkLoading.subtitle")}
        </h3> */}

        <p style={{ margin: "0 0 20px", color: "#666", fontSize: "14px" }}>
          {t("maatwerkLoading.description")} {t("maatwerkLoading.autoRedirect")}
        </p>

        <div
          style={{
            backgroundColor: "#E8F4FC",
            borderRadius: "8px",
            padding: "12px 16px",
            margin: "0px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Clock />
            <span
              style={{ color: "#439BD9", fontSize: "14px", fontWeight: 500 }}
            >
              {t("maatwerkLoading.estimatedTime")}
            </span>
          </div>
          <b style={{ color: "#666", fontSize: "13px" }}>
            {t("maatwerkLoading.doNotLeave")}
          </b>
        </div>
      </div>
    </CustomModal>
  );
};

export default MaatwerkLoadingModal;
